(ns hai.notes.routes
  (:require
   [hai.notes.detail :as detail]
   [hai.notes.eql :as eql]
   [hai.notes.page :as page]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as-alias routing]))

(defn routes []
  [["/notes"
    {:label "Notes"
     :icon (icons/mui-icon :outlined :sticky_note_2)}
    [""
     {:name :notes/view
      :view page/page}]
    ["/{note/uuid}"
     {:name :notes/detail
      ::routing/window-title ::detail/window-title
      :breadcrumbs [:notes/view "Note"]
      :view detail/page
      :controllers [{:parameters {:path [:note/uuid]}
                     :start (fn [{path :path}]
                              (>e [:entity/resolve path
                                   {;; The same shape the editor's other hosts
                                    ;; resolve, so a note is one thing wherever
                                    ;; it is opened.
                                    :pattern       eql/note-eql
                                    :on-success-fx [[:dispatch [::detail/mark-resolved (:note/uuid path)]]]
                                    :on-error-fx   [[:dispatch [::detail/mark-resolved (:note/uuid path)]]]}]))}]}]]])
